import { useApolloClient, useMutation } from '@apollo/client';
import { TokenSession } from '@avangard/utils/token';
import { useNavigate } from '@avangard/utils/routing';

import { routes } from '@config/routes';
import { RevokeTokenMutation } from '@modules/auth/graphql';

import type { RevokeTokenMutationType, RevokeTokenMutationVariables } from '@modules/types/graphql';

const useLogout = () => {
    const apolloClient = useApolloClient();
    const navigate = useNavigate();

    const [logout, { loading: logoutLoading }] = useMutation<
        RevokeTokenMutationType,
        RevokeTokenMutationVariables
    >(RevokeTokenMutation);

    const handleClickLogout = async (): Promise<void> => {
        const refreshToken = TokenSession.getCurrentSession().getRefreshToken().getToken();

        if (!refreshToken) {
            return;
        }

        try {
            await logout({ variables: { refreshToken } });
        } catch (e) {
            console.log(e);
        } finally {
            TokenSession.destroyCurrentSession();
            await apolloClient.clearStore();
            await navigate(routes.login.path, { replace: true });
        }
    };

    return {
        handleClickLogout,
        logoutLoading,
    };
};

export { useLogout };
